'use strict';

(function () {
  'use strict';

  angular.module('login').config(loginConfig);

  loginConfig.$inject = ['$stateProvider', 'errorRouterProvider', 'assessmentRouterProvider', 'onboardingRouterProvider'];

  function loginConfig($stateProvider, errorRouterProvider, assessmentRouterProvider, onboardingRouterProvider) {
    init();

    function init() {
      _registerRootRoute();
      _registerLogoutRoute();
      _registerErrorRoutes();
      _registerAssessmentRoutes();
      _registerLoginRoutes();
    }

    function _registerRootRoute() {
      $stateProvider.state('root', {
        abstract: true,
        url: '/?isMobileWebView&mobilePlatform',
        resolve: {
          isMobileWebView: ['stateParams', function (stateParams) {
            return stateParams['isMobileWebView'];
          }],
          mobilePlatform: ['stateParams', function (stateParams) {
            return stateParams['mobilePlatform'];
          }]
        }
      });
    }

    function _registerLogoutRoute() {
      $stateProvider.state('logout', {
        url: '/logout',
        templateUrl: 'core/pages/logout.html',
        controller: 'logoutCtrl'
      });
    }

    function _registerErrorRoutes() {
      var errorRoutes = errorRouterProvider.buildRoutes();
      //wire the routes
      for (var index in errorRoutes) {
        if (errorRoutes.hasOwnProperty(index)) {
          var route = errorRoutes[index];
          if (route.hasOwnProperty('name')) {
            $stateProvider.state(route.name, route);
          }
        }
      }
    }

    function _registerAssessmentRoutes() {
      //set the translation prefix and any other context-specific info
      assessmentRouterProvider.setContext({
        translatePrefix: 'login'
      });
      //build the routes
      var assessmentRoutes = assessmentRouterProvider.buildRoutes();
      //wire the routes
      for (var index in assessmentRoutes) {
        if (assessmentRoutes.hasOwnProperty(index)) {
          var route = assessmentRoutes[index];
          if (route.hasOwnProperty('name')) {
            $stateProvider.state(route.name, route);
          }
        }
      }
    }

    function _registerLoginRoutes() {
      onboardingRouterProvider.configure('login');
      var loginRoutes = onboardingRouterProvider.buildLoginRoutes();
      //wire the routes
      for (var index in loginRoutes) {
        if (loginRoutes.hasOwnProperty(index)) {
          var route = loginRoutes[index];
          if (route.hasOwnProperty('name')) {
            $stateProvider.state(route.name, route);
          }
        }
      }
    }
  }
})();